import { InputNumber } from 'antd';
import React from 'react';
const InputAmount = (props) => {
  return <InputNumber min={0} precision={2} step="0.01" {...props} />;
};

export default InputAmount;
